import { useMutation } from "react-query";
import { axios } from "../lib/request";
import { useParams } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { useTranslation } from "react-i18next";
import { alertState } from "../common/AlertDisplay/AlertDisplay.state";

export const useExportGameMutation = () => {
  const { game_id } = useParams();
  const { t } = useTranslation();
  const setAlert = useSetRecoilState(alertState);

  return useMutation(
    async ({ email, media, featured, watermark }) => {
      const url = `${process.env.REACT_APP_API_EXPORT_URL}/${game_id}/export.json`;
      const response = await axios.patch(url, { email, media, featured, watermark });
      return response;
    },
    {
      onSuccess: () => {
        setAlert({
          type: "info",
          message: t("Exporting game is processing! You will get notified once export is ready to download."),
          autoClose: true,
          closable: true,
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      onError: () => {
        setAlert({
          type: "error",
          message: t("Failed to export game. Please try again."),
          autoClose: true,
          closable: true,
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    }
  );
};

